export default __webpack_public_path__ + "static/media/cancel.3b93edca.svg";